import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processFileData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Url='/student';
const backUrl='/student'+Url;
const studentUrl='/studentDependence';
const courseYearUrl='/getallcourse-year';
const courseSemesterUrl='/getallcourse-semester';


class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            graduation:'',
            other_scholarship:'',
            name:'',
            pincode:'',
            city:'',
            status:1,
            email_id:'',
            aadhar_no:'',
            whats_app_no:'',
            dob:'',
            start_year:'',
            end_year:'',
            mobile:'',
            phone:'',
            joining_date:'',
            blood_group_id:'',
            course_quota:0,
            gender:'',
            father_name:'',
            father_occupation:'',
            mother_name:'',
            mother_occupation:'',
            address:'',
            community_id:'',
            religion_id:'',
            semester_name:'', 
            course_id:'',
            course_year_id:'',
            course_sem_id:'',
            courseData:[],
            courseYearData:[],
            courseSemData:[],
            bloodGroupData:[],
            communityData:[],
            religionData:[],
            photo:'',
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
        this.getCourseYearData=this.getCourseYearData.bind(this);
        this.getCourseSemensterData=this.getCourseSemensterData.bind(this);
        this.handleChangeDobDate=this.handleChangeDobDate.bind(this);
        this.handleChangeJoiningDate=this.handleChangeJoiningDate.bind(this);
    }


    componentDidMount(){
        viewData(studentUrl).then((res)=>{
            if(res.data.status===200){
                const data=res.data;
                this.setState({ 
                    bloodGroupData:data.bloodGroupData,
                    courseData:data.courseData,
                    communityData:data.communityData,
                    religionData:data.religionData,
                    preloader:false
                });
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data;
                            this.getCourseYearData(data.course_id);
                            this.setState({
                                semester_name:data.semester_name?data.semester_name:'', 
                                course_id:data.course_id?data.course_id:'', 
                                course_year_id:data.course_year_id?data.course_year_id:'', 
                                course_sem_id:data.course_sem_id?data.course_sem_id:'', 
                                name:data.name,
                                email_id:data.email_id,
                                id_no:data.id_no,
                                aadhar_no:data.aadhar_no, 
                                graduation:data.graduation,
                                other_scholarship:data.other_scholarship,
                                whats_app_no:data.whats_app_no,
                                mobile:data.mobile,
                                phone:data.phone,
                                gender:data.gender,
                                address:data.address,
                                city:data.city,
                                pincode:data.pincode,
                                father_name:data.father_name,
                                father_occupation:data.father_occupation,
                                mother_name:data.mother_name,
                                mother_occupation:data.mother_occupation,
                                community_id:data.community_id,
                                religion_id:data.religion_id, 
                                course_quota:data.course_quota,
                                status:data.status,
                                blood_group_id:data.blood_group_id, 
                                dob:data.dob!='0000-00-00' ?moment(new Date(data.dob)):'',
                                joining_date:moment(new Date(data.joining_date)),
                                hosteler:data.hosteler,
                                photo:data.photo,
                                preloader:false, 
                            },()=>{
                                this.getCourseSemensterData(data.course_id,data.course_year_id);
                            }); 
                        }
                    });
                } 
            }
        });
    }

    handleChangeDobDate(date) {
        this.setState({ dob: moment(date)});
    }
 
    handleChangeJoiningDate(date) {
        this.setState({ joining_date: moment(date)});
    }
 

    getCourseYearData(id){
        viewData(courseYearUrl+'/'+id).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({courseYearData:datam}); 
            }
        });
    }
    
    getCourseSemensterData(id,yearid){
        viewData(courseSemesterUrl+'/'+id+'/'+yearid).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({courseSemData:datam}); 
            }
        });
    }

    setStateFromInput=(event)=> {
        var obj = {};
        if(event.target.name=='course_id' && event.target.value){
            this.getCourseYearData(event.target.value);
        }
        if(event.target.name=='course_year_id' && event.target.value){
            this.getCourseSemensterData(this.state.course_id,event.target.value);
        }
        const radioVal=['gender','status','other_scholarship','graduation','hosteler','course_quota'];
        obj[event.target.name] = radioVal.includes(event.target.name)?event.target.value==0?1:0:event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if(this.validator.allValid()){
            let {hosteler,name,email_id,aadhar_no,course_id,dob,other_scholarship,graduation,whats_app_no,mobile,phone,gender,address,city,pincode,father_name,father_occupation,mother_name,mother_occupation,community_id,religion_id,joining_date,course_quota,status,blood_group_id,id_no,course_year_id,course_sem_id} =this.state;
            let formData = new FormData();
            let imagefile = document.querySelector('#upload');
            //if(imagefile.files[0])
            formData.append('pic', imagefile.files[0]);
                
            formData.append('name',name);
            formData.append('email_id',email_id);
            formData.append('id_no',id_no);
            formData.append('hosteler',hosteler);
            formData.append('aadhar_no',aadhar_no);
            formData.append('course_id',course_id);
            formData.append('dob',moment(dob));
            formData.append('graduation',graduation);
            formData.append('other_scholarship',other_scholarship);
            formData.append('whats_app_no',whats_app_no);
            formData.append('mobile',mobile);
            formData.append('phone',phone);
            formData.append('gender',gender);
            formData.append('address',address);
            formData.append('city',city);
            formData.append('pincode',pincode);
            formData.append('father_name',father_name);
            formData.append('father_occupation',father_occupation);
            formData.append('mother_name',mother_name);
            formData.append('mother_occupation',mother_occupation);
            formData.append('community_id',community_id);
            formData.append('religion_id',religion_id);
            formData.append('joining_date',moment(joining_date));
            formData.append('course_quota',course_quota);
            formData.append('status',status);
            formData.append('blood_group_id',blood_group_id);
            formData.append('course_year_id',course_year_id);
            formData.append('course_sem_id',course_sem_id);
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processFileData(Url+para,formData).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,course_id,courseData,course_year_id,courseYearData,name,id_no,email_id,aadhar_no,course_sem_id,courseSemData, whats_app_no,
            mobile,
            phone,
            dob,
            joining_date,
            father_name,
            father_occupation,
            mother_name,
            address,
            pincode,
            city,
            status,
            community_id,
            religion_id,
            mother_occupation,
            communityData,
            religionData,
            hosteler,
            course_quota,
            graduation,other_scholarship,blood_group_id,bloodGroupData,gender,photo} = this.state;
        let role=permissionCheck('student',title);
        if(!role)
            return <Nopermission/>;
        const nameValid= this.validator.message('Course',name, 'required');
        const id_noValid= this.validator.message('Course',id_no, 'required');
        const aadhar_noValid= this.validator.message('Course',aadhar_no, 'required');
        const email_idValid= this.validator.message('Course',email_id, 'required');
        const course_idValid= this.validator.message('Course',course_id, 'required');
        const course_year_idValid= this.validator.message('Course Year',course_year_id, 'required');
        const course_sem_idValid= this.validator.message('Semester Name',course_sem_id, 'required');
        const genderValid= this.validator.message('Gender',gender, 'required|numeric');
        const dobValid= this.validator.message('Date Of Birth',dob, 'required');
        const joining_dateValid= this.validator.message('Joining Date',joining_date, 'required');
        const community_idValid= this.validator.message('Community',community_id, 'required');
        const religion_idValid= this.validator.message('Religion',religion_id, 'required');
        const father_nameValid= this.validator.message('Father Name',father_name, 'required');
        const father_occupationValid= this.validator.message('Father Occupation',father_occupation, 'required');
        const mother_nameValid= this.validator.message('Mother Name',mother_name, 'required');
        const mother_occupationValid= this.validator.message('Mother Occupation',mother_occupation, 'required');
        /*const whats_app_noValid= this.validator.message('WhatsApp No',whats_app_no, 'numeric');
        const mobileValid= this.validator.message('Mobile',mobile, 'numeric');
        const phoneValid= this.validator.message('Phone',phone, 'numeric');*/
        const hostelerValid= this.validator.message('Hosteler',hosteler, 'required|numeric');
        const addressValid= this.validator.message('Address',address, 'required');
        const cityValid= this.validator.message('City',city, 'required');
        const pincodeValid= this.validator.message('Pincode',pincode, 'required');
        const course_quotaValid= this.validator.message('Course Quota',course_quota, 'required|numeric');
        /* const graduationValid= this.validator.message('First Graduation',graduation, 'required');
        const other_scholarshipValid= this.validator.message('Other Scholarship',other_scholarship, 'required'); */
        const statusValid= this.validator.message('Status',status, 'required|numeric');
        const blood_group_idValid= this.validator.message('Blood Group',blood_group_id, 'required'); 

        return (
            <div id="page_content_inner">
                <h3 className="heading_b uk-margin-bottom">{title} Student</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Name<span className="req">*</span></label>
                                    <input type="text" name="name" value={name} onChange={this.setStateFromInput} className={ `md-input ${nameValid ?'md-input-danger':''}`} /> 
                                    {nameValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${id_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="ID No">ID No<span className="req">*</span></label>
                                    <input type="text" name="id_no" value={id_no} onChange={this.setStateFromInput} className={ `md-input ${id_noValid ?'md-input-danger':''}`} /> 
                                    {id_noValid} 
                                </div>
                            </div>
                       
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${email_id ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email Id">Email Id<span className="req">*</span></label>
                                    <input type="text" name="email_id" value={email_id} onChange={this.setStateFromInput} className={ `md-input ${email_idValid ?'md-input-danger':''}`} /> 
                                    {email_idValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${aadhar_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">Aadhar No<span className="req">*</span></label>
                                    <input type="text" name="aadhar_no" value={aadhar_no} onChange={this.setStateFromInput} className={ `md-input ${aadhar_noValid ?'md-input-danger':''}`} /> 
                                    {aadhar_noValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${course_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className={ `datepicker md-input ${course_idValid ?'md-input-danger':''}`} name="course_id" onChange={this.setStateFromInput} value={course_id}>
                                        <option value="">Select Course</option>
                                        {
                                            courseData && courseData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.course_id} >{val.course_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {course_idValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${course_year_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className={ `datepicker md-input ${course_year_idValid ?'md-input-danger':''}`} name="course_year_id" onChange={this.setStateFromInput} value={course_year_id}>
                                        <option value="">Select Year</option>
                                        {
                                            courseYearData && courseYearData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.course_year_id} >{val.year_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {course_year_idValid} 
                                </div>
                            </div>
                            

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${course_sem_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className={ `datepicker md-input ${course_sem_idValid ?'md-input-danger':''}`} name="course_sem_id" onChange={this.setStateFromInput} value={course_sem_id}>
                                        <option value="">Select Semester</option>
                                        {
                                            courseSemData && courseSemData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.course_sem_id} >{val.semester_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {course_sem_idValid} 
                                </div>
                            </div> 
                            <div className="uk-width-medium-1-4"> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">
                                        <input checked={gender==1?1:0} onChange={this.setStateFromInput} type="radio" name="gender" id="radio_demo_1" value="0" />
                                        <label htmlFor="radio_demo_1" className="inline-label">Male</label>
                                        <input type="radio" name="gender" id="radio_demo_2" checked={gender==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="radio_demo_2" className="inline-label">Female</label>
                                    </span>
                                    {genderValid} 
                                </div>
                            </div> 
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${dob ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">DOB<span className="req">*</span></label>
                                    <DatePicker showYearDropdown showMonthDropdown scrollableYearDropdown  yearDropdownItemNumber={20} selected={dob} dateFormat="DD/MM/YYYY" className={ `datepicker md-input ${dobValid ?'md-input-danger':''}`}  onChange={this.handleChangeDobDate} /> 
                                    {dobValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${joining_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">Joining Date<span className="req">*</span></label>
                                    <DatePicker showYearDropdown showMonthDropdown scrollableYearDropdown  yearDropdownItemNumber={20} selected={joining_date} dateFormat="DD/MM/YYYY"  className={ `datepicker md-input ${joining_dateValid ?'md-input-danger':''}`} onChange={this.handleChangeJoiningDate} /> 
                                    {joining_dateValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${community_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${community_idValid ?'md-input-danger':''}`} name="community_id" onChange={this.setStateFromInput} value={community_id}>
                                        <option value="">Select Community</option>
                                        {
                                            communityData && communityData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.community_id} >{val.community_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {community_idValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${religion_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${religion_idValid ?'md-input-danger':''}`} name="religion_id" onChange={this.setStateFromInput} value={religion_id}>
                                        <option value="">Select Nationality</option>
                                        {
                                            religionData && religionData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.religion_id} >{val.religion_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {religion_idValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${father_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Father Name">Father Name<span className="req">*</span></label>
                                    <input type="text" name="father_name" value={father_name} onChange={this.setStateFromInput} className={ `md-input ${father_nameValid ?'md-input-danger':''}`} /> 
                                    {father_nameValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${father_occupation ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Father Occupation">Father Occupation<span className="req">*</span></label>
                                    <input type="text" name="father_occupation" value={father_occupation} onChange={this.setStateFromInput} className={ `md-input ${father_occupationValid ?'md-input-danger':''}`} /> 
                                    {father_occupationValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${mother_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mother Name">Mother Name<span className="req">*</span></label>
                                    <input type="text" name="mother_name" value={mother_name} onChange={this.setStateFromInput} className={ `md-input ${mother_nameValid ?'md-input-danger':''}`} /> 
                                    {mother_nameValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${mother_occupation ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mother Occupation">Mother Occupation<span className="req">*</span></label>
                                    <input type="text" name="mother_occupation" value={mother_occupation} onChange={this.setStateFromInput} className={ `md-input ${mother_occupationValid ?'md-input-danger':''}`} /> 
                                    {mother_occupationValid} 
                                </div>
                            </div>
                        </div>
                             
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${whats_app_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="WhatsApp No">WhatsApp No</label>
                                    <input type="text" name="whats_app_no" value={whats_app_no} onChange={this.setStateFromInput} className={ `md-input`} /> 
                    
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${mobile ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Mobile</label>
                                    <input type="text" name="mobile" value={mobile} onChange={this.setStateFromInput} className={ `md-input`} /> 
                                    
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${phone ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Phone">Phone</label>
                                    <input type="text" name="phone" value={phone} onChange={this.setStateFromInput} className={ `md-input`} /> 
                                    
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                
                                <div className="md-input-wrapper md-radio">
                                    <span style={{paddingRight:'4px'}}>Hosteler<span className="req">*</span></span> 
                                    <span className="md-radio">
                                        <input checked={hosteler==1?1:0} onChange={this.setStateFromInput} type="radio" name="hosteler" id="hosteler_1" value="0" />
                                        <label htmlFor="hosteler_1" className="inline-label">Yes</label>
                                        <input type="radio" name="hosteler" id="hosteler_2" checked={hosteler==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="hosteler_2" className="inline-label">No</label>
                                    </span>
                                    {hostelerValid} 
                                </div>
                            </div> 
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${address ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Address">Address<span className="req">*</span></label>
                                    <input type="text" name="address" value={address} onChange={this.setStateFromInput} className={ `md-input ${addressValid ?'md-input-danger':''}`} /> 
                                    {addressValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${city ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="City">City<span className="req">*</span></label>
                                    <input type="text" name="city" value={city} onChange={this.setStateFromInput} className={ `md-input ${cityValid ?'md-input-danger':''}`} /> 
                                    {cityValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${pincode ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Pincode">Pincode<span className="req">*</span></label>
                                    <input type="text" name="pincode" value={pincode} onChange={this.setStateFromInput} className={ `md-input ${pincodeValid ?'md-input-danger':''}`} /> 
                                    {pincodeValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                
                                <div className="md-input-wrapper md-radio">
                                    <span style={{paddingRight:'4px'}}>Quota</span> 
                                    <span className="md-radio">
                                        <input checked={course_quota==1?1:0} onChange={this.setStateFromInput} type="radio" name="course_quota" id="course_quota_1" value="0" />
                                        <label htmlFor="course_quota_1" className="inline-label">M.Q</label>
                                        <input type="radio" name="course_quota" id="course_quota_2" checked={course_quota==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="course_quota_2" className="inline-label">G.Q</label>
                                    </span>
                                    {course_quotaValid} 
                                </div>
                            </div> 
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${blood_group_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1"  className={ `datepicker md-input ${blood_group_idValid ?'md-input-danger':''}`} name="blood_group_id" onChange={this.setStateFromInput} value={blood_group_id}>
                                        <option value="">Select Blood Group</option>
                                        {
                                            bloodGroupData && bloodGroupData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.blood_group_id} >{val.blood_group}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {blood_group_idValid} 
                                </div>
                            </div>
                            
                            <div className="uk-width-medium-1-4"> 
                                <div className="md-input-wrapper checkbox-div" >
                                    <span className="md-checkbox">
                                        <input checked={graduation==1?1:0} onChange={this.setStateFromInput} type="checkbox" name="graduation" id="graduation" value={graduation} />
                                        <label htmlFor="graduation" className="inline-label">First Graduation</label> 
                                    </span> 
                                </div>
                            </div> 

                            <div className="uk-width-medium-1-4"> 
                                <div className="md-input-wrapper checkbox-div">
                                    <span className="md-checkbox">
                                        <input checked={other_scholarship==1?1:0} onChange={this.setStateFromInput} type="checkbox" name="other_scholarship" id="other_scholarship" value={other_scholarship} />
                                        <label htmlFor="other_scholarship" className="inline-label">Other Scholarship</label> 
                                    </span>  
                                </div>
                            </div>  
                           
                            <div className="uk-width-medium-1-4"> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">
                                        <input checked={status==1?1:0} onChange={this.setStateFromInput} type="radio" name="status" id="status_1" value="0" />
                                        <label htmlFor="status_1" className="inline-label">Active</label>
                                        <input type="radio" name="status" id="status_2" checked={status==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="status_2" className="inline-label">In-Active</label>
                                    </span>
                                    {statusValid} 
                                </div>
                            </div> 
                        </div>
                        
                        <div className="uk-grid">
                     
                            <div className="uk-width-1-4">
                                        { photo &&
                                            <div className="thumbnail">
                                            <img style={{width:'100px',height:'100px'}} src={photo} alt="user avatar" class=""/>
                                        </div>
                                        }
                            </div>
                        </div>
                        <div className="uk-grid">
                            <div className="uk-width-1-4">
                                <div className="uk-form-file md-btn md-btn-small md-btn-primary">
                                Student Photo
                                    <input id="upload" type="file"/>
                                </div> 
                            </div> 
                        </div>
     
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Student/Student/addEdit.js